import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-to-reorder rows on the playlist's "Features in playlist" table.
// On drop, POSTs the new order (feature_ids[] in visual order) to
// /admin/playlists/:id/reorder_features. The server renumbers
// FeaturePlaylistMembership#position to match. The visible "Pos."
// column gets re-numbered client-side so the user sees the change
// before the next page load.
//
// The controller mounts on the <tbody> — each <tr> carries
// data-feature-id so we can serialize the new order without DOM
// scraping.
export default class extends Controller {
  static values = {
    url: String,
    csrf: String
  }

  connect() {
    this._sortable = Sortable.create(this.element, {
      handle: "[data-reorder-handle]",
      animation: 150,
      ghostClass: "playlist-reorder__ghost",
      onEnd: () => this._persist()
    })
  }

  disconnect() {
    if (this._sortable) this._sortable.destroy()
    this._sortable = null
  }

  _persist() {
    const rows = Array.from(this.element.querySelectorAll("tr[data-feature-id]"))
    const ids = rows.map((r) => r.dataset.featureId).filter(Boolean)

    // Renumber the visible position column so the user gets immediate
    // visual feedback that the drop "stuck".
    rows.forEach((row, idx) => {
      const posCell = row.querySelector("[data-reorder-position]")
      if (posCell) posCell.textContent = idx
    })

    const body = new FormData()
    ids.forEach((id) => body.append("feature_ids[]", id))

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": this.csrfValue || this._readCsrf(),
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      body
    }).catch((err) => {
      console.error("[playlist-reorder]", err)
    })
  }

  _readCsrf() {
    return document.querySelector("meta[name='csrf-token']")?.content || ""
  }
}
